// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cn9TQm","pagination":"Ao2aqV"};